/**
 * Spellcheck configuration.
 * Kept as an object so it can be moved to a feature flag or appconfig later if needed.
 * Keep simple rules grouped here so we can tweak during the pilot based on data and expert feedback.
 */
export interface SpellCheckConfig {
    /** timeout for the spellcheck API call */
    apiTimeoutMs: number;
    /** how long to wait after the last keystroke before running an optimistic spellcheck */
    debounceMs: number;
    /** minimum number of characters for an optimistic run of spellcheck */
    minCharsForBackgroundCheck: number;
    /** how long to show a success message after a spellcheck success */
    successDisplayMs: number;
    /** how long to show an error message after a spellcheck error */
    errorDisplayMs: number;
    /** show additional button to send the original message instead of the corrected one */
    allowSendOriginal: boolean;
    /** replace the input with the corrected text or restore the original text on cancel */
    replaceInputWithCorrectedOnCancel: boolean;
}

export const SPELLCHECK_CONFIG: SpellCheckConfig = {
    apiTimeoutMs: 15000,
    debounceMs: 1000,
    minCharsForBackgroundCheck: 10,
    successDisplayMs: 3000,
    errorDisplayMs: 3000,
    allowSendOriginal: false,
    replaceInputWithCorrectedOnCancel: true,
};
